import { registerComponent } from '../../lib/vulcan-lib/components';
import React from 'react';

export const DictionaryIcon = (props: React.HTMLAttributes<SVGElement>) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      version="1.1"
      id="svg1"
      xmlSpace="preserve"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <defs id="defs1" />
      <path fill="currentColor"
        d="m 17.548387,6.6991949 c 2.599122,0 4.68944,1.9862226 4.68944,4.4559121 0,2.469689 -2.090318,4.45616 -4.68944,4.45616 -2.599122,0 -4.68944,-1.986471 -4.68944,-4.45616 0,-2.4696895 2.090318,-4.4559121 4.68944,-4.4559121 z M 5.0429552,3.7288347 H 15.98524 c 0.440938,0 0.781313,0.3236725 0.781313,0.742652 v 0.7893152 c -3.077184,0.367427 -5.470751,2.8734441 -5.470751,5.8943051 0,1.369511 0.493042,2.632392 1.317601,3.639057 l -3.4333203,3.262408 c -0.3053347,0.290129 -0.3053347,0.760537 0,1.050419 0.3052695,0.290129 0.8001355,0.290129 1.1051443,0 l 3.43293,-3.26216 c 0.865006,0.63967 1.909644,1.069233 3.048461,1.205138 v 3.017209 c 0,0.41898 -0.34044,0.742405 -0.781312,0.742405 H 5.0429552 Z M 2.6984958,2.2435308 c -1.2855578,0 -2.34472001,1.0061697 -2.34472001,2.2279559 V 20.067178 c 0,1.221539 1.05916221,2.227708 2.34472001,2.227708 H 8.1695089 15.98524 c 1.285558,0 2.34446,-1.006169 2.34446,-2.227708 v -3.017023 c 3.077445,-0.367427 5.471273,-2.873878 5.471273,-5.895048 0,-3.0211086 -2.393828,-5.5273113 -5.471273,-5.8945527 V 4.4714867 c 0,-1.2217862 -1.058902,-2.2279559 -2.34446,-2.2279559 z"
        id="path1"
        style={{ strokeWidth: 0.0634887 }}
      />
    </svg>
  );
};
